import { render, staticRenderFns } from "./FileSummary.vue?vue&type=template&id=5f3a9f8c&"
import script from "./FileSummary.vue?vue&type=script&lang=js&"
export * from "./FileSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports